import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty";

const pessoa_juridica = {
  razao_social: "",
  nome: "",
  cnpj: "",
  ie: null,
  endereco: endereco_empty(),
  contatos: contatos_empty(),
};

export default { ...pessoa_juridica };
